import { render, staticRenderFns } from "./WeightsPath.vue?vue&type=template&id=1bebb636&"
import script from "./WeightsPath.vue?vue&type=script&lang=ts&"
export * from "./WeightsPath.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports